import { createUseStyles } from 'react-jss';
import { ITheme } from '../theme';

export const borderInput = {
  '& fieldset': { borderColor: '#6CA370' },
  '& label': { color: '#0B170C' },
};

type RuleNames =
  | 'chatContent'
  | 'contentInput';

const PREFIX = 'ChatContent';
export const useStyles = createUseStyles<RuleNames, unknown, ITheme>(
  (theme: ITheme) => (
    {
      chatContent: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '56.5%',
        height: '100%',
        background: 'rgba(79, 94, 84, 0.05)',
        borderRadius: '0 10px 10px 0',
        justifyContent: 'space-between',
        position: 'relative',
        '& .MuiFormLabel-root': {
          color: '#999999',
        },
        '& .MuiInputLabel-shrink': {
          color: theme.darkGreen,
        },
      },
      contentInput: {
        height: '41px',
        width: '93%',
        marginBottom: 24,
        '& .MuiInputBase-input': {
          padding: '9px 14px',
          height: '0px',
        },
        '& .MuiInputBase-root': {
          height: '41px',
        },
        '& .MuiButtonBase-root': {
          padding: 0,
        },
        '& .MuiOutlinedInput-root': {
          '&.Mui-focused': {
            '& .MuiOutlinedInput-notchedOutline': {
              border: '1px solid black',
            },
            '& .MuiOutlinedLabel': {
              color: 'black',
            },
          },
        },
        '& .MuiFormLabel-root': {
          fontWeight: 400,
          top: '-7px',
          '&.Mui-focused': {
            color: 'black',
          },
        },
      },
    }
  ),
  { name: PREFIX },
);
